export const getTimezone = () =>
  Intl.DateTimeFormat("en-US").resolvedOptions().timeZone || "Asia/Tashkent";

// TODO: This returns undefined on Chrome 117
// https://support.google.com/chrome/thread/231926653/timezone-return-undefined?hl=en
